// components/CallToActionSection.jsx
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function CallToActionSection() {
  return (
    <Box
      component="section"
      sx={{
        py: 10,
        textAlign: 'center',
        background: 'linear-gradient(to right, #ff6600, #ff944d)',
        color: 'white',
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Ready to Get Started?
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 4 }}>
        Join thousands of learners achieving their goals online.
      </Typography>
      <Button
        variant="contained"
        size="large"
        sx={{ bgcolor: 'white', color: '#ff6600', fontWeight: 'bold', '&:hover': { bgcolor: '#fff2e6' } }}
        href="/register"
      >
        Sign Up Now
      </Button>
    </Box>
  );
}
